import React, { useState } from 'react'
import './navbar.css';
import icon1 from '../../assets/images/icon.png'
import  {Link} from 'react-scroll'
import MobileNav from './MobileNav/MobileNav';
import { GiHamburgerMenu } from "react-icons/gi"
import { PiNotchesBold } from "react-icons/pi";
const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false)
  const toggleMenu=()=>{
    setOpenMenu(!openMenu)
  }
  return (
    <>
    <MobileNav isOpen={openMenu} toogleMenu={toggleMenu}/>
    <nav
    className='nav-wrapper'>
      <div className='nav-content'>
        <a href='' ><h1 className='senmosdev'>SENMOSDEV</h1></a>
        <ul>
          <li>
            <a href="" className="menu-item">
              Home 
            </a>
            </li>
          <li>
            <a href="#skills-container" className="menu-item">
              Skills
            </a>
            </li>
          <li>
            <a href="#portfolio" className="menu-item">
              Portfolio
            </a>
            </li>
          <li>
            <a href="#contact" className="menu-item">
              Contact Me
            </a>
            </li>
            
            
        </ul>
        <button className='menu-btn' onClick={toggleMenu}>
        
           {openMenu? <PiNotchesBold />:<GiHamburgerMenu />}
          
        </button>
      </div>
    </nav>
    </>
    
   )
}

export default Navbar;
